import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import { showToast } from '../../utils/toast';
import ROUTES from '../../routes';
import { handleErrors } from '../../utils/common';

const ResetPwd = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const formRef = useRef(null);
    const [newPassword, setNewPassword] = useState('');

    const handleFormSubmit = async () => {
        if (!formRef.current) return;

        const $ = window.jQuery;

        if (!$(formRef.current).valid()) return;

        try {
            const res = await axios.post(
                `/auth/reset-password/${token}`,
                { newPassword },
                {
                    baseURL: process.env.REACT_APP_API_URL,
                    withCredentials: true,
                }
            );

            if (res.status === 200) {
                showToast('success', res.data.message || 'Password reset successful', 'Success');

                setTimeout(() => {
                    navigate(ROUTES.LOGIN);
                }, 1500);
            }
        } catch (err) {
            handleErrors(err);
        }
    };

    useEffect(() => {
        const $ = window.jQuery;

        if (!formRef.current || !$.fn.validate) return;

        $(formRef.current).validate({
            rules: {
                newPassword: {
                    required: true,
                    minlength: 8
                }
            },
            messages: {
                newPassword: {
                    required: "Please enter your new password",
                    minlength: "Password must be at least 8 characters"
                }
            },
            errorClass: "invalid-feedback animated fadeInUp",
            errorElement: "div",
            errorPlacement: function (error, element) {
                $(element).closest(".form-group").append(error);
            },
            highlight: function (element) {
                $(element).addClass("is-invalid");
            },
            unhighlight: function (element) {
                $(element).removeClass("is-invalid");
            }
        });
    }, []);

    return (
        <div className="card-body">
            <div className="text-center mb-3">
                <a href="#/"><img className="logo-auth" src="/assets/logo.png" alt="logo" /></a>
            </div>
            <h4 className="text-center mb-4">Reset Password</h4>
            <form ref={formRef} noValidate>
                <div className="form-group mb-3">
                    <label className="form-label">New Password</label>
                    <div className="position-relative">
                        <input
                            name="newPassword"
                            value={newPassword}
                            type="password"
                            className="form-control"
                            onChange={(e) => setNewPassword(e.target.value)}
                        />
                    </div>
                </div>
                <div className="text-center">
                    <button type="button" onClick={handleFormSubmit} className="btn btn-primary btn-block">Send</button>
                </div>
            </form>
        </div>
    );
};

export default ResetPwd;
